var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0489 9.99234C16.5078 11.2969 16.8573 11.9494 17.3292 12.4212C17.8009 12.8929 18.4535 13.2413 19.758 13.7002L22.2119 14.4927V15.2563L19.758 16.0488C18.4536 16.5076 17.8009 16.8561 17.3292 17.3278C16.8573 17.7995 16.5079 18.4531 16.0489 19.7579L15.2564 22.2118H14.494L13.7016 19.7579C13.2426 18.4531 12.8932 17.7995 12.4213 17.3278C11.9496 16.856 11.2969 16.5076 9.99248 16.0488L7.53856 15.2563V14.4927L9.99248 13.7002C11.2969 13.2413 11.9496 12.893 12.4213 12.4212C12.8932 11.9494 13.2426 11.2969 13.7016 9.99234C14.1606 8.68756 14.494 7.53717 14.494 7.53717H15.2276L16.0489 9.99234Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92978 2.59422L9.09969 4.21679C8.67687 5.09844 8.52421 5.59957 8.52414 6.07134C8.52414 6.5432 8.67678 7.04402 9.09969 7.92588L9.92978 9.54971L9.54859 9.9309L7.92477 9.09955C7.04362 8.67702 6.54307 8.52538 6.07148 8.52525C5.5997 8.52525 5.09848 8.67682 4.21693 9.09955L2.59311 9.9309L2.21191 9.54971L3.04201 7.92588C3.46493 7.04401 3.61756 6.5432 3.61756 6.07134C3.61748 5.59957 3.46482 5.09845 3.04201 4.21679C2.62347 3.34411 2.22003 2.60897 2.21191 2.59422L2.57806 2.22682L4.21693 3.04312C5.09863 3.46595 5.59965 3.61867 6.07148 3.61867C6.54311 3.61854 7.04345 3.46575 7.92477 3.04312L9.54859 2.21303L9.92978 2.59422Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLabel);
export default __webpack_public_path__ + "static/media/AILabel.1e4ff8eba4d30165fdab28f2e1ec42bd.svg";
export { ForwardRef as ReactComponent };